import { onEnterPress } from "helpers/a11y-helper";
import React, { useState, type ReactNode } from "react";
import PlusIcon from "images/sprites/reb/svg/plus-icon.svg";
import MinusIcon from "images/sprites/reb/svg/minus-icon.svg";
import { overrideTailwindClasses } from "tailwind-override";

export type ExpandablePillProps = {
  leftAlignedHeader: ReactNode;
  rightAlignedHeader?: ReactNode;
  expandedContent: ReactNode;
  classNames?: string;
  toggleDataTestId?: string;
  isOpen?: boolean;
  onClick?: () => void;
};

const ExpandablePill = ({
  leftAlignedHeader,
  rightAlignedHeader = null,
  expandedContent,
  classNames = "",
  toggleDataTestId = "",
  isOpen,
  onClick,
}: ExpandablePillProps) => {
  //Allow component state/click handlers to be managed by parent or internally
  const [isOpenState, setIsOpenState] = useState(false);
  const isToggleOpen = isOpen ?? isOpenState;

  const toggleAccordion = () => setIsOpenState(!isOpen);

  const renderIcon = () => (isOpen ? <MinusIcon /> : <PlusIcon />);

  const classes = overrideTailwindClasses(`rounded-xl bg-white px-4 ${classNames}`);

  return (
    <div className={classes}>
      <div className="flex justify-between items-center min-h-14">
        {leftAlignedHeader}
        <div className="flex justify-between items-end gap-4">
          {rightAlignedHeader}
          <button
            data-test-id={toggleDataTestId}
            onClick={onClick ?? toggleAccordion}
            onKeyDown={onEnterPress(onClick) ?? onEnterPress(toggleAccordion)}>
            {renderIcon()}
          </button>
        </div>
      </div>
      {isToggleOpen && expandedContent}
    </div>
  );
};

export default ExpandablePill;
